import { PLACEHOLDER_BUTTON__bar } from './PLACEHOLDER_BUTTON__bar';

export function PLACEHOLDER_BUTTON__bar_10_5() {
  return <PLACEHOLDER_BUTTON__bar class_name_button="w-10 h-5" />;
}
